var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.handleTabClick },
          model: {
            value: _vm.activeTab,
            callback: function ($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "New Grant", name: "new" } },
            [
              _c(
                "el-card",
                {
                  staticStyle: { "margin-bottom": "20px" },
                  attrs: { shadow: "never" },
                },
                [
                  _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                    _c("span", [_vm._v("Filters")]),
                  ]),
                  _c(
                    "el-form",
                    { attrs: { "label-width": "120px", size: "small" } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Countries" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                multiple: "",
                                filterable: "",
                                placeholder: "All countries",
                              },
                              on: { change: _vm.onFilterChange },
                              model: {
                                value: _vm.filters.countries,
                                callback: function ($$v) {
                                  _vm.$set(_vm.filters, "countries", $$v)
                                },
                                expression: "filters.countries",
                              },
                            },
                            _vm._l(_vm.countryOptions, function (c) {
                              return _c("el-option", {
                                key: c.countryCode,
                                attrs: {
                                  label: `${
                                    c.countryCode
                                  } - ${_vm.getCountryName(
                                    c.countryCode
                                  )} (${_vm.formatNumber(c.userCount)})`,
                                  value: c.countryCode,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Features" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                multiple: "",
                                filterable: "",
                                placeholder: "All features",
                              },
                              on: { change: _vm.onFilterChange },
                              model: {
                                value: _vm.filters.featureIds,
                                callback: function ($$v) {
                                  _vm.$set(_vm.filters, "featureIds", $$v)
                                },
                                expression: "filters.featureIds",
                              },
                            },
                            _vm._l(_vm.featureOptions, function (f) {
                              return _c("el-option", {
                                key: f.id,
                                attrs: { label: f.name, value: f.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Device Type" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                multiple: "",
                                filterable: "",
                                placeholder: "All device types",
                              },
                              on: { change: _vm.onFilterChange },
                              model: {
                                value: _vm.filters.deviceTypes,
                                callback: function ($$v) {
                                  _vm.$set(_vm.filters, "deviceTypes", $$v)
                                },
                                expression: "filters.deviceTypes",
                              },
                            },
                            _vm._l(_vm.deviceTypeOptions, function (d) {
                              return _c("el-option", {
                                key: d.deviceType,
                                attrs: {
                                  label: `${d.deviceType} (${_vm.formatNumber(
                                    d.deviceCount
                                  )} devices)`,
                                  value: d.deviceType,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Has Cane" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "300px" },
                              attrs: { placeholder: "All", clearable: "" },
                              on: { change: _vm.onFilterChange },
                              model: {
                                value: _vm.filters.hasCane,
                                callback: function ($$v) {
                                  _vm.$set(_vm.filters, "hasCane", $$v)
                                },
                                expression: "filters.hasCane",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "All", value: null },
                              }),
                              _c("el-option", {
                                attrs: { label: "Yes", value: true },
                              }),
                              _c("el-option", {
                                attrs: { label: "No", value: false },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-card",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.previewLoading,
                      expression: "previewLoading",
                    },
                  ],
                  staticStyle: { "margin-bottom": "20px" },
                  attrs: { shadow: "never" },
                },
                [
                  _c(
                    "div",
                    { attrs: { slot: "header" }, slot: "header" },
                    [
                      _c("span", [_vm._v("Preview")]),
                      _c(
                        "el-button",
                        {
                          staticStyle: { float: "right" },
                          attrs: {
                            size: "mini",
                            type: "primary",
                            icon: "el-icon-refresh",
                          },
                          on: { click: _vm.fetchPreview },
                        },
                        [_vm._v(" Refresh ")]
                      ),
                    ],
                    1
                  ),
                  _vm.preview
                    ? _c(
                        "div",
                        { staticClass: "preview-section" },
                        [
                          _c("div", { staticClass: "preview-total" }, [
                            _c("span", { staticClass: "preview-count" }, [
                              _vm._v(
                                _vm._s(_vm.formatNumber(_vm.preview.totalCount))
                              ),
                            ]),
                            _c("span", { staticClass: "preview-label" }, [
                              _vm._v(" users match these criteria"),
                            ]),
                            _vm.preview.deviceCount !== undefined
                              ? _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "margin-top": "5px",
                                      color: "#909399",
                                      "font-size": "14px",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.formatNumber(
                                            _vm.preview.deviceCount
                                          )
                                        ) +
                                        " active devices "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                          _vm.preview.countryCounts &&
                          _vm.preview.countryCounts.length > 0
                            ? _c(
                                "el-table",
                                {
                                  staticStyle: {
                                    width: "100%",
                                    "margin-top": "15px",
                                  },
                                  attrs: {
                                    data: _vm.preview.countryCounts,
                                    border: "",
                                    fit: "",
                                    size: "mini",
                                  },
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: { label: "Country", width: "200" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ row }) {
                                            return [
                                              _vm._v(
                                                _vm._s(row.countryCode) +
                                                  " - " +
                                                  _vm._s(
                                                    _vm.getCountryName(
                                                      row.countryCode
                                                    )
                                                  )
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1065847075
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "Users",
                                      width: "120",
                                      align: "center",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ row }) {
                                            return [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.formatNumber(row.count)
                                                )
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      4121897149
                                    ),
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _c("div", { staticClass: "preview-empty" }, [
                        _vm._v(" Select filters to see user count "),
                      ]),
                ]
              ),
              _c(
                "el-card",
                {
                  staticStyle: { "margin-bottom": "20px" },
                  attrs: { shadow: "never" },
                },
                [
                  _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                    _c("span", [_vm._v("Grant Settings")]),
                  ]),
                  _c(
                    "el-form",
                    { attrs: { "label-width": "140px", size: "small" } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Grant Type" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.grantForm.grantType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.grantForm, "grantType", $$v)
                                },
                                expression: "grantForm.grantType",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: "weassist" } }, [
                                _vm._v("WeAssist (Consult Time)"),
                              ]),
                              _c(
                                "el-radio",
                                { attrs: { label: "entitlement" } },
                                [_vm._v("Feature Entitlement")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.grantForm.grantType === "entitlement"
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "Grant Target" } },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  model: {
                                    value: _vm.grantForm.grantTarget,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.grantForm,
                                        "grantTarget",
                                        $$v
                                      )
                                    },
                                    expression: "grantForm.grantTarget",
                                  },
                                },
                                [
                                  _c("el-radio", { attrs: { label: "user" } }, [
                                    _vm._v("User Only"),
                                  ]),
                                  _c(
                                    "el-radio",
                                    { attrs: { label: "device" } },
                                    [_vm._v("Device Only")]
                                  ),
                                  _c("el-radio", { attrs: { label: "both" } }, [
                                    _vm._v("Both (User + Device)"),
                                  ]),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    color: "#909399",
                                    "font-size": "12px",
                                    "margin-top": "4px",
                                  },
                                },
                                [
                                  _vm.grantForm.grantTarget === "user"
                                    ? _c("span", [
                                        _vm._v(
                                          "Feature will be added to user_entitlements"
                                        ),
                                      ])
                                    : _vm.grantForm.grantTarget === "device"
                                    ? _c("span", [
                                        _vm._v(
                                          "Feature will be added to device_features (" +
                                            _vm._s(
                                              _vm.preview
                                                ? _vm.formatNumber(
                                                    _vm.preview.deviceCount || 0
                                                  )
                                                : "?"
                                            ) +
                                            " active devices)"
                                        ),
                                      ])
                                    : _c("span", [
                                        _vm._v(
                                          "Feature will be added to both user_entitlements and device_features"
                                        ),
                                      ]),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.grantForm.grantType === "weassist"
                        ? [
                            _c(
                              "el-form-item",
                              { attrs: { label: "Duration (seconds)" } },
                              [
                                _c("el-input-number", {
                                  staticStyle: { width: "200px" },
                                  attrs: { min: 0, max: 36000, step: 60 },
                                  model: {
                                    value: _vm.grantForm.durationSeconds,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.grantForm,
                                        "durationSeconds",
                                        $$v
                                      )
                                    },
                                    expression: "grantForm.durationSeconds",
                                  },
                                }),
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      "margin-left": "10px",
                                      color: "#606266",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " = " +
                                        _vm._s(
                                          _vm.formatMinutes(
                                            _vm.grantForm.durationSeconds
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              { attrs: { label: "Quick Set" } },
                              [
                                _c(
                                  "el-button-group",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          size: "small",
                                          type:
                                            _vm.grantForm.durationSeconds ===
                                            300
                                              ? "primary"
                                              : "default",
                                        },
                                        on: {
                                          click: function ($event) {
                                            _vm.grantForm.durationSeconds = 300
                                          },
                                        },
                                      },
                                      [_vm._v("5 min")]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          size: "small",
                                          type:
                                            _vm.grantForm.durationSeconds ===
                                            600
                                              ? "primary"
                                              : "default",
                                        },
                                        on: {
                                          click: function ($event) {
                                            _vm.grantForm.durationSeconds = 600
                                          },
                                        },
                                      },
                                      [_vm._v("10 min")]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          size: "small",
                                          type:
                                            _vm.grantForm.durationSeconds ===
                                            900
                                              ? "primary"
                                              : "default",
                                        },
                                        on: {
                                          click: function ($event) {
                                            _vm.grantForm.durationSeconds = 900
                                          },
                                        },
                                      },
                                      [_vm._v("15 min")]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          size: "small",
                                          type:
                                            _vm.grantForm.durationSeconds ===
                                            1800
                                              ? "primary"
                                              : "default",
                                        },
                                        on: {
                                          click: function ($event) {
                                            _vm.grantForm.durationSeconds = 1800
                                          },
                                        },
                                      },
                                      [_vm._v("30 min")]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          size: "small",
                                          type:
                                            _vm.grantForm.durationSeconds ===
                                            2700
                                              ? "primary"
                                              : "default",
                                        },
                                        on: {
                                          click: function ($event) {
                                            _vm.grantForm.durationSeconds = 2700
                                          },
                                        },
                                      },
                                      [_vm._v("45 min")]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          size: "small",
                                          type:
                                            _vm.grantForm.durationSeconds ===
                                            3600
                                              ? "primary"
                                              : "default",
                                        },
                                        on: {
                                          click: function ($event) {
                                            _vm.grantForm.durationSeconds = 3600
                                          },
                                        },
                                      },
                                      [_vm._v("60 min")]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              { attrs: { label: "Expires Date" } },
                              [
                                _c("el-date-picker", {
                                  staticStyle: { width: "300px" },
                                  attrs: {
                                    type: "datetime",
                                    placeholder: "Select expiry date",
                                  },
                                  model: {
                                    value: _vm.grantForm.expiresDate,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.grantForm,
                                        "expiresDate",
                                        $$v
                                      )
                                    },
                                    expression: "grantForm.expiresDate",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        : _vm._e(),
                      _vm.grantForm.grantType === "entitlement"
                        ? [
                            _c(
                              "el-form-item",
                              { attrs: { label: "Feature" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      placeholder: "Select feature to grant",
                                    },
                                    model: {
                                      value: _vm.grantForm.grantFeatureId,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.grantForm,
                                          "grantFeatureId",
                                          $$v
                                        )
                                      },
                                      expression: "grantForm.grantFeatureId",
                                    },
                                  },
                                  _vm._l(_vm.featureOptions, function (f) {
                                    return _c("el-option", {
                                      key: f.id,
                                      attrs: {
                                        label: `${f.name} (${f.featureKey})`,
                                        value: f.id,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              { attrs: { label: "Duration Type" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "300px" },
                                    model: {
                                      value: _vm.grantForm.grantDurationType,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.grantForm,
                                          "grantDurationType",
                                          $$v
                                        )
                                      },
                                      expression: "grantForm.grantDurationType",
                                    },
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: {
                                        label: "Permanent",
                                        value: "permanent",
                                      },
                                    }),
                                    _c("el-option", {
                                      attrs: { label: "Days", value: "days" },
                                    }),
                                    _c("el-option", {
                                      attrs: {
                                        label: "Months",
                                        value: "months",
                                      },
                                    }),
                                    _c("el-option", {
                                      attrs: { label: "Years", value: "years" },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm.grantForm.grantDurationType !== "permanent"
                              ? _c(
                                  "el-form-item",
                                  { attrs: { label: "Duration Value" } },
                                  [
                                    _c("el-input-number", {
                                      staticStyle: { width: "200px" },
                                      attrs: { min: 1 },
                                      model: {
                                        value: _vm.grantForm.grantDurationValue,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.grantForm,
                                            "grantDurationValue",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "grantForm.grantDurationValue",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        : _vm._e(),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Description" } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              rows: 2,
                              placeholder: "Admin note (optional)",
                            },
                            model: {
                              value: _vm.grantForm.description,
                              callback: function ($$v) {
                                _vm.$set(_vm.grantForm, "description", $$v)
                              },
                              expression: "grantForm.description",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "danger",
                                icon: "el-icon-s-promotion",
                                loading: _vm.executeLoading,
                                disabled:
                                  !_vm.preview ||
                                  _vm.preview.totalCount === 0 ||
                                  (_vm.grantForm.grantType === "weassist"
                                    ? !_vm.grantForm.durationSeconds ||
                                      !_vm.grantForm.expiresDate
                                    : !_vm.grantForm.grantFeatureId),
                              },
                              on: { click: _vm.handleExecute },
                            },
                            [_vm._v(" Execute Bulk Grant ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                ],
                1
              ),
              _vm.executeResult
                ? _c(
                    "el-card",
                    { attrs: { shadow: "never" } },
                    [
                      _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                        _c("span", [_vm._v("Result")]),
                      ]),
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c("el-col", { attrs: { span: 6 } }, [
                            _c("div", { staticClass: "stat-card" }, [
                              _c("div", { staticClass: "stat-label" }, [
                                _vm._v("Total Users"),
                              ]),
                              _c("div", { staticClass: "stat-value" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatNumber(
                                      _vm.executeResult.totalUsers
                                    )
                                  )
                                ),
                              ]),
                            ]),
                          ]),
                          _c("el-col", { attrs: { span: 6 } }, [
                            _c("div", { staticClass: "stat-card" }, [
                              _c("div", { staticClass: "stat-label" }, [
                                _vm._v("Success"),
                              ]),
                              _c(
                                "div",
                                { staticClass: "stat-value stat-success" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.formatNumber(
                                        _vm.executeResult.successCount
                                      )
                                    )
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                          _c("el-col", { attrs: { span: 6 } }, [
                            _c("div", { staticClass: "stat-card" }, [
                              _c("div", { staticClass: "stat-label" }, [
                                _vm._v("Errors"),
                              ]),
                              _c(
                                "div",
                                {
                                  staticClass: "stat-value",
                                  class: {
                                    "stat-error":
                                      _vm.executeResult.errorCount > 0,
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.formatNumber(
                                        _vm.executeResult.errorCount
                                      )
                                    )
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                          _vm.executeResult.deviceSuccessCount !== undefined
                            ? _c("el-col", { attrs: { span: 6 } }, [
                                _c("div", { staticClass: "stat-card" }, [
                                  _c("div", { staticClass: "stat-label" }, [
                                    _vm._v("Devices"),
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "stat-value stat-success" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatNumber(
                                            _vm.executeResult.deviceSuccessCount
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                          _c("el-col", { attrs: { span: 6 } }, [
                            _c("div", { staticClass: "stat-card" }, [
                              _c("div", { staticClass: "stat-label" }, [
                                _vm._v("Log ID"),
                              ]),
                              _c("div", { staticClass: "stat-value" }, [
                                _vm._v("#" + _vm._s(_vm.executeResult.logId)),
                              ]),
                            ]),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "History", name: "history" } },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.historyLoading,
                      expression: "historyLoading",
                    },
                  ],
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.historyList,
                    border: "",
                    fit: "",
                    "highlight-current-row": "",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "ID", width: "60", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [_vm._v(_vm._s(row.id))]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "Filters", "min-width": "220" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            row.filters
                              ? _c(
                                  "div",
                                  [
                                    _vm._l(
                                      row.filters.countries || [],
                                      function (c) {
                                        return _c(
                                          "el-tag",
                                          {
                                            key: "c-" + c,
                                            staticStyle: { margin: "2px" },
                                            attrs: {
                                              size: "mini",
                                              type: "primary",
                                            },
                                          },
                                          [_vm._v(_vm._s(c))]
                                        )
                                      }
                                    ),
                                    _vm._l(
                                      row.filters.featureIds || [],
                                      function (fId) {
                                        return _c(
                                          "el-tag",
                                          {
                                            key: "f-" + fId,
                                            staticStyle: { margin: "2px" },
                                            attrs: {
                                              size: "mini",
                                              type: "warning",
                                            },
                                          },
                                          [_vm._v("Feature #" + _vm._s(fId))]
                                        )
                                      }
                                    ),
                                    _vm._l(
                                      row.filters.deviceTypes || [],
                                      function (dt) {
                                        return _c(
                                          "el-tag",
                                          {
                                            key: "d-" + dt,
                                            staticStyle: { margin: "2px" },
                                            attrs: {
                                              size: "mini",
                                              type: "info",
                                            },
                                          },
                                          [_vm._v(_vm._s(dt))]
                                        )
                                      }
                                    ),
                                    row.filters.hasCane === true
                                      ? _c(
                                          "el-tag",
                                          {
                                            staticStyle: { margin: "2px" },
                                            attrs: {
                                              size: "mini",
                                              type: "success",
                                            },
                                          },
                                          [_vm._v("Has Cane")]
                                        )
                                      : _vm._e(),
                                    row.filters.hasCane === false
                                      ? _c(
                                          "el-tag",
                                          {
                                            staticStyle: { margin: "2px" },
                                            attrs: {
                                              size: "mini",
                                              type: "info",
                                            },
                                          },
                                          [_vm._v("No Cane")]
                                        )
                                      : _vm._e(),
                                    row.filters.grantType === "entitlement"
                                      ? _c(
                                          "el-tag",
                                          {
                                            staticStyle: { margin: "2px" },
                                            attrs: {
                                              size: "mini",
                                              type: "danger",
                                            },
                                          },
                                          [_vm._v("Entitlement")]
                                        )
                                      : _vm._e(),
                                  ],
                                  2
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "Duration", width: "100", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _vm._v(
                              _vm._s(_vm.formatMinutes(row.durationSeconds))
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "Expires", width: "160" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _vm._v(_vm._s(_vm.formatDate(row.expiresDate))),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "Total", width: "80", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _vm._v(_vm._s(_vm.formatNumber(row.totalUsers))),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "Success", width: "80", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c("span", { staticStyle: { color: "#67C23A" } }, [
                              _vm._v(
                                _vm._s(_vm.formatNumber(row.successCount))
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "Errors", width: "80", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "span",
                              {
                                style: {
                                  color:
                                    row.errorCount > 0 ? "#F56C6C" : "inherit",
                                },
                              },
                              [_vm._v(_vm._s(row.errorCount || 0))]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "Status", width: "100", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  type:
                                    row.status === "completed"
                                      ? "success"
                                      : row.status === "failed"
                                      ? "danger"
                                      : row.status === "running"
                                      ? "warning"
                                      : "info",
                                  size: "mini",
                                },
                              },
                              [_vm._v(_vm._s(row.status))]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "Created By", width: "120" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [_vm._v(_vm._s(row.createdBy || "-"))]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "Created At", width: "160" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [_vm._v(_vm._s(_vm.formatDate(row.createdAt)))]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm.historyPagination.totalCount > 0
                ? _c("el-pagination", {
                    staticStyle: {
                      "margin-top": "20px",
                      "text-align": "center",
                    },
                    attrs: {
                      background: "",
                      layout: "prev, pager, next, total",
                      total: _vm.historyPagination.totalCount,
                      "page-size": _vm.historyPagination.pageSize,
                      "current-page": _vm.historyPagination.currentPage,
                    },
                    on: {
                      "update:currentPage": function ($event) {
                        return _vm.$set(
                          _vm.historyPagination,
                          "currentPage",
                          $event
                        )
                      },
                      "update:current-page": function ($event) {
                        return _vm.$set(
                          _vm.historyPagination,
                          "currentPage",
                          $event
                        )
                      },
                      "current-change": _vm.fetchHistory,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }